module.exports = __webpack_public_path__ + "static/media/logo-dark-snc-1.bff903c2.svg";